// extracted by mini-css-extract-plugin
export default {"root":"ModalOverlay_root__GSDlq","blur-down":"ModalOverlay_blur-down__NUyhy","blur-up":"ModalOverlay_blur-up__XmylR"};